module.exports = __webpack_public_path__ + "95273cca29693cae74fd719932cb7751.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/left_hand/gavel.png
// module id = 3008
// module chunks = 0